export default __webpack_public_path__ + "static/media/Level0.2cfb8073.svg";